import React from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { orders } from "../../../common/data";
import { Link } from "react-router-dom";

const EcommerceOrders = () => {

  const breadcrumbItems = [
    { title: "Ecommerce", link: "/" },
    { title: "Orders", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Orders"
            breadcrumbItems={breadcrumbItems}
          />
          <Card>
            <CardBody>
              <div className="table-responsive">
                <table className="table table-centered align-middle table-nowrap mb-0 table-bordered">
                  <thead className="table-light text-muted">
                    <tr>
                      <th>ID</th>
                      <th>Order ID</th>
                      <th>Date</th>
                      <th>Billing Name</th>
                      <th>Total</th>
                      <th>Payment Status</th>
                      <th>Invoice</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders && orders.length > 0 ? (
                      orders.map((order, index) => (
                        <tr key={index}>
                          <td>{order.id}</td>
                          <td>{order.orderid}</td>
                          <td>{order.orderdate}</td>
                          <td>{order.billingname}</td>
                          <td>{order.total}</td>
                          <td>
                            {order.paymentStatus === "Paid" ? (
                              <span className="badge bg-success-subtle text-success text-uppercase">
                                {order.paymentStatus}
                              </span>
                            ) : order.paymentStatus === "unpaid" ? (
                              <span className="badge bg-warning-subtle text-warning text-uppercase">
                                {order.paymentStatus}
                              </span>
                            ) : (
                              <span className="badge bg-danger-subtle text-danger text-uppercase">
                                {order.paymentStatus}
                              </span>
                            )}
                          </td>
                          <td>
                            <button className="btn btn-light btn-rounded">
                              Invoice <i className="mdi mdi-download ms-2"></i>
                            </button>
                          </td>
                          <td>
                            <Link to="#" className="me-3 text-primary">
                              <i className="mdi mdi-pencil font-size-18"></i>
                            </Link>
                            <Link to="#" className="text-danger">
                              <i className="mdi mdi-trash-can font-size-18"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">No orders found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EcommerceOrders;
